import rootScope from '@lib/rootScope';
import wrapSticker from '@components/wrappers/sticker'
import {Modify} from '@types';

export default async function wrapStickerEmoji(options: Modify<Parameters<typeof wrapSticker>[0], {
  div: HTMLElement,
  doc?: never
}>) {
  const {
    emoji,
    div,
    managers = rootScope.managers
  } = options;
  const doc = await managers.appStickersManager.getAnimatedEmojiSticker(emoji);
  if(!doc) {
    // LainGram: the emoji sticker set may be empty (unseeded server). Render
    // the plain emoji text instead of throwing so callers that don't catch
    // ('no sticker' used to escape as an unhandled rejection and kill menus).
    div.classList.add('media-sticker-wrapper');
    const span = document.createElement('span');
    span.style.fontSize = 'inherit';
    span.textContent = emoji;
    div.appendChild(span);
    return {
      render: Promise.resolve(div as HTMLImageElement),
      load: () => Promise.resolve([] as HTMLImageElement[]),
      width: 0,
      height: 0,
      downloaded: true
    } as unknown as ReturnType<typeof wrapSticker>;
  }

  return wrapSticker({
    doc,
    play: true,
    loop: false,
    ...options
  });
}
